import { jsx } from 'react/jsx-runtime';
import SettingsIcon from '@material-ui/icons/Settings';
import { settingsRouteRef } from '../plugin.esm.js';
import { SidebarItem } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { userSettingsTranslationRef } from '../translation.esm.js';

const Settings = (props) => {
  const routePath = useRouteRef(settingsRouteRef);
  const Icon = props.icon ? props.icon : SettingsIcon;
  const { t } = useTranslationRef(userSettingsTranslationRef);
  return /* @__PURE__ */ jsx(SidebarItem, { text: t("sidebarTitle"), to: routePath(), icon: Icon });
};

export { Settings };
//# sourceMappingURL=Settings.esm.js.map
